import {useEffect} from 'react'
import About from 'components/About'
import NftSlider from 'components/NftSlider'
import RoadMap from 'components/RoadMap'
import Faq from 'components/Faq'
import JoinCommunity from 'components/Join'
import Team from "components/OurTeam";
import Story from "components/Story";
import MintSec from "components/MintSec";

const Home = () => {

    return (
        <main>
            <About />
            <MintSec />
            <NftSlider />
            <Story />
            <JoinCommunity />
            <RoadMap />
            <Faq />
            <Team />
        </main>
    )
}

export default Home

